import { useState } from "react";

export const Tooltip = ({ text, children }) => {
	const [show, setShow] = useState(false);

	const handleMouseEnter = () => {
		setShow(true);
	};

	const handleMouseLeave = () => {
		setShow(false);
	};

	return (
		<div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
			<div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
				{children}
			</div>
			{show && (
				<div
					style={{
						position: "absolute",
						top: "50%",
						left: "-50%",
						transform: "translateX(-50%)",
						backgroundColor: "white",
						color: "gray",
						padding: "5px",
						borderRadius: "5px",
						pointerEvents: "none",
						boxShadow:
							"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
					}}
				>
					{text}
				</div>
			)}
		</div>
	);
};